import {Component, ContentChildren, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Subject, Subscription} from 'rxjs';
import * as _ from 'lodash';
import * as moment from 'moment';
import {FormGroup} from '@angular/forms';
import {filter, take, takeUntil} from 'rxjs/operators';
import {NotificationType} from 'src/shared/constants/notification-type.enum';
import {AddInfoModel} from 'src/shared/model/add-info.model';
import {BsModalRef, BsModalService, ModalOptions} from 'ngx-bootstrap/modal';
import {NotificationService} from 'src/shared/service/notification.service';
import {HttpCustomService} from 'src/service/http-custom.service';
import {ActionState} from 'src/shared/constants/action-state.enum';
import {CommonConstants} from 'src/shared/constants/common-constants.enum';
import {CommonInits} from 'src/shared/constants/common-init';
import {ConfirmationDialogComponent} from '../confirmation-dialog/confirmation-dialog.component';
import {HttpMethod} from "../../constants/http-method.enum";

@Component({
  selector: 'dcu-add-new-form',
  templateUrl: './add-new-form.component.html',
  styleUrls: ['./add-new-form.component.scss']
})
export class AddNewFormComponent implements OnInit {

  @Input()
  info: AddInfoModel;

  @Input()
  nextLabel = 'Next';

  @Input()
  isNoticed = false;

  @Output()
  onSave: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onNext: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onSaveClose: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onClose: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  customOnSave: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  customOnSaveClose: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  customOnNext: EventEmitter<any> = new EventEmitter<any>();

  @ContentChildren('addContent') someElement;

  form: FormGroup;

  ngUnsubscribe: Subject<void> = new Subject<void>();

  subscriptions: Subscription[] = [];

  config: ModalOptions = {
    backdrop: true,
    ignoreBackdropClick: true,
    class: 'modal-dialog-centered'
  };

  constructor(
    public dialogRef: BsModalRef,
    private notificationService: NotificationService,
    private dialogService: BsModalService,
    private httpService: HttpCustomService
  ) {
  }


  validateAndSubmitForm(funcCallBack: any) {
    const formGroup = this.someElement.last.formGroup as FormGroup;

    const controlNames = Object.keys(formGroup.controls);
    formGroup.markAsPristine();
    formGroup.markAllAsTouched();
    if ('INVALID' === formGroup.status) {
      return;
    }

    if ('VALID' !== formGroup.status) {
      // If form has status valid(<=> form valid) then submit form
      this.subscriptions.push(formGroup.statusChanges
        .pipe(take(1), filter(item => 'VALID' === item))
        .subscribe(() => {
          funcCallBack();
          this.unsubscribe();
        })
      );
    } else {
      funcCallBack();
    }
  }

  onButtonSaveNew(event?) {
    if(this.info.isCustomAction){
      const form = this.someElement.last.formGroup as FormGroup;
      this.customOnSave.emit(form);
      return;
    }
    this.validateAndSubmitForm(() => {
      this.form = this.someElement.last.formGroup as FormGroup;
      if (!this.info.model) {
        this.info.model = {};
      }

      _.assign(this.info.model, this.form.getRawValue());
      this.formatData(this.info.model, {
        date: ['effectiveStartDate', 'effectiveEndDate'],
      });
      this.httpService
        .request(this.info.method ? this.info.method : HttpMethod.POST, this.info.urlStatement, this.info.model)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          res => {
            if (res) {
              this.notificationService.showPerformSuccessOneRecord(ActionState.NEW);
              this.onSave.emit(res);
            }
          }
        );
    });
  }

  onButtonSaveClose(event?) {
    if(this.info.isCustomAction){
      const form = this.someElement.last.formGroup as FormGroup;
      if (this.info.isNextButton){
        this.customOnNext.emit(form);
      } else {
        this.customOnSaveClose.emit(form);
      }
      return;
    }
    this.validateAndSubmitForm(() => {
      this.form = this.someElement.last.formGroup as FormGroup;
      this.form.markAsPristine();
      this.form.markAllAsTouched();
      if (!this.info.model) {
        this.info.model = {};
      }

      _.assign(this.info.model, this.form.getRawValue());
      this.formatData(this.info.model, {
        date: ['effectiveStartDate', 'effectiveEndDate'],
      });
      this.httpService
        .request(this.info.method ? this.info.method : HttpMethod.POST, this.info.urlStatement, this.info.model)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(res => {
          if (res) {
            this.notificationService.showPerformSuccessOneRecord(ActionState.NEW);
          }
          if (this.info.isNextButton) {
            this.dialogRef.hide();
            this.onNext.emit(res);
          } else {
            this.onSaveClose.emit(res);
            this.dialogRef.hide();
          }
        });
    });
  }

  onButtonClose(event?) {
    if (this.isUserMakeAnyChange()) {
      const confirmState = this.dialogService.show(
        ConfirmationDialogComponent,
        {
          initialState: CommonInits.confirmDialogForUnsavedData(
            ActionState.CLOSE
          )
        }
      );

      confirmState.setClass('modal-dialog-centered');
      this.subscriptions.push(this.dialogService.onHide
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(() => {
          if (confirmState.content.confirmed) {
            this.dialogRef.hide();
            this.onClose.emit(event);
          }
          this.unsubscribe();
        })
      );
    } else {
      this.dialogRef.hide();
    }
  }

  ngOnInit() {
  }

  ngAfterContentInit(): void {
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.unsubscribe();
  }

  formatData(obj, keys) {
    Object.keys(keys).forEach((key) => {
      switch (key) {
        case 'date':
          keys[key].filter(dKey => !_.isNil(obj[dKey])).forEach(dKey => {
            obj[dKey] = moment(obj[dKey]).format('YYYY-MM-DD');
          });
          break;
        case 'number':
          keys[key].filter(nKey => !_.isNil(obj[nKey])).forEach(nKey => {
            obj[nKey] = obj[nKey].replace(/,/gi, '');
          });
          break;
      }
    });
  }

  isUserMakeAnyChange() {
    this.form = this.someElement.last.formGroup as FormGroup;
    if (this.someElement.last.defaultValue) {
      const defaultValue = this.someElement.last.defaultValue;
      const dv = _.mapValues(_.omitBy(defaultValue, _.isNil ), value => {
        if (value && _.isDate(value)) {
          return moment(value).format('YYYY-MM-DD');
        }
        return value;
      })

      const fv = _.mapValues(_.omitBy(this.form.getRawValue(), _.isNil ), value => {
        if (value && _.isDate(value)) {
          return moment(value).format('YYYY-MM-DD');
        }
        return value;
      })

      return !_.isEqual(dv, fv);
    }
    return _.some(this.form.getRawValue(),
      (value: any) => _.size(value) > 0 && !_.isArray(value));
  }

  private unsubscribe() {
    _.forEach(this.subscriptions, (subscription: Subscription) => {
      subscription.unsubscribe();
    });
    this.subscriptions = [];
  }

}
